module.exports = __webpack_public_path__ + "static/mg-4afd82ba5085625ee949463b9f4f565c.jpeg";